module.exports = __webpack_public_path__ + "img/myinvestor.1a65bb4f.svg";